// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"styles_logoWrapper__AR1A6"};